import { FC, useContext, useEffect } from "react"
import { IFormSelectProps } from "components/Form/FormComponents/FormVehiclePicker/formvehiclepicker.interface"
import { useApi } from "auth/useApi3"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useTranslation } from "react-i18next"
import { apiEndpoints } from "generated/apiEndpoints"
import { StyledFormLabel } from "shared/styled/Global"
import { Autocomplete, Box, FormControl, TextField, Typography, useTheme } from "@mui/material"
import { isJson } from "components/TinyMCE/helpers"
import { AppContext } from "components/AppContextProvider"

type SelectOptions = Array<{ value: string; name: string; }>

const FormBPLStationPicker: FC<IFormSelectProps> = (props) => {
  const { id, labelKey, labelDefault, handleChange, value, optional, helperText, error } = props
  const [bplStationResult, bplStationApi] = useApi() as [IApiResult, IApiFunc]
  const appContext = useContext(AppContext)
  const { t } = useTranslation()
  const theme = useTheme()

  useEffect(() => {
    const companyId = appContext?.appUser?.app?.mainCompanyId || 0
    bplStationApi.get(apiEndpoints.customeradmin.getbpltypes.replace("{companyId}", companyId))
  }, [appContext?.appUser?.app?.mainCompanyId])

  const stations: SelectOptions = bplStationResult?.data?.stations?.map((station: any) => ({
    value: station.id,
    name: station.namn,
  })) || []

  return (
    <>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })} {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      <FormControl fullWidth>
        <Autocomplete
          loading
          loadingText={t("global.loading", "Loading") + "..."}
          sx={{ width: "100%", background: theme.palette.background.paper }}
          id={id?.toString()}
          options={stations}
          getOptionLabel={(option) => option.name}
          onChange={(_, option) => handleChange && handleChange(option?.value)}
          includeInputInList
          renderOption={(props, option) => (
            <li {...props}>
              <Box sx={{ fontWeight: 600, minWidth: "100px" }}>{option.name}</Box>
            </li>
          )}
          value={stations?.find((i) =>
            i.value?.toString() === value?.toString() ||
            (isJson(value) && i.value?.toString() === JSON.parse(value)?.Id?.toString())
          ) || null}
          renderInput={(params) => (
            <TextField
              {...params}
              name={id?.toString()}
              variant="outlined"
              error={error}
              helperText={helperText}
            />
          )}
        />
      </FormControl>
    </>
  )
}

export default FormBPLStationPicker